export default {
  "Singapore Expo": {
    name: "新加坡会展中心",
    projectType: "钢结构工程",
    developer: "",
    tenure: "",
    psf: "65,000m²",
    completionYear: "1999",
    totalUnits: "",
    desc: "MCC Singapore was responsible for the design, fabrication and installation of the 7,000-tonnes steel structure works for the Singapore Expo project that spanned 96 metres with a gross floor area of 65,000 square metres. The Singapore Expo is the largest convention and exhibition venue in Singapore with over 100,000 square metres of column-free, indoor space spread over 10 halls. The centre was designed by Cox Richardson Rayner, built by PSA International, and funded by the Ministry of Trade and Industry. The S$220 million building (excluding the cost of the 40,000 square metres expansion) is located in Tampines, Singapore, and was officially opened in 1999.",
    website:"",
    location: {lat: 1.3335351545820713, lng: 103.95953934409192},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/project-public/expo/1.jpg')},
    ]
  },
  "Woodlands Checkpoint": {
    name: "兀兰关口",
    projectType: "建筑工程",
    developer: "",
    tenure: "",
    psf: "1,056m",
    completionYear: "1998",
    totalUnits: "",
    desc: `The new Woodlands Checkpoint, built partially on reclaimed land, was opened in 1999 to accommodate the increasing traffic flow and the soot which had enveloped the old customs complex over the years. The new checkpoint complex also houses the Woodlands Train Checkpoint, which opened in 1998, as the Singapore railway border clearance facility.
    The Johor-Singapore Causeway is a 1,056-metre causeway that connects the city of Johor Bahru in Malaysia across the Straits of Johor to the town of Woodlands in Singapore. It serves as a road and rail link, as well as a water pipeline between the two countries. It is one of the busiest border crossings in the region, handled by the immigration authorities of both countries.
    `,
    website:"",
    location: {lat: 1.4458888, lng: 103.7662695},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/project-public/woodlands/1.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/project-public/woodlands/2.jpg')},
      {id: 2, imageSrc: require('@/assets/images/constructions/project-public/woodlands/3.jpg')},
      {id: 3, imageSrc: require('@/assets/images/constructions/project-public/woodlands/4.jpg')},
    ]
  },
  "Keppel Distripark": {
    name: "新加坡吉宝物流中心",
    projectType: "钢结构工程",
    developer: "",
    tenure: "",
    psf: "60,000m²",
    completionYear: "1993",
    totalUnits: "",
    desc: `China Jingye Engineering Corporation Limited (Singapore Branch) was the contractor responsible for the 6,000-tonnes long-span cable-stayed truss steel structures for the project, spanning 98 metres with a gross floor area of 60,000 square metres. Keppel Distripark comprises four blocks of a two-storey Container Freight Station (CFS) Building, one block of four-storey office buildings, stacking yards and other related facilities. The Distripark was completed in 1993.
      ppel Distripark is a modern cargo distribution complex that provides extensive warehousing and office facilities. It is directly linked to terminals of the Port of Singapore Authority (PSA), allowing goods to enter the port swiftly. The Distripark’s proximity to an extensive network of expressways also allows easy access to the city, airport and industrial hubs.
    `,
    website:"",
    location: {lat: 1.2720028, lng: 103.8258498},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/project-public/keppel-distripark/img-kepple.jpg')},
    ]
  },
  "Tagore 66KV Electrical Substation": {
    name: "Tagore 66KV变电站",
    projectType: "基础工程项目",
    developer: "",
    tenure: "",
    psf: "5,391.5m²",
    completionYear: "2020",
    totalUnits: "",
    desc: `A project worth S$17 million awarded by the Urban Redevelopment Authority (URA) of Singapore, the electrical substation designed and constructed by China Jingye Engineering Corporation Limited (Singapore Branch) covers an area of 3,220.46 square metres, comprising three basements and two blocks of two-storey ground buildings with a total floor area of 5,391.5 square metres. Located at the intersection of Thomson Road and Tagore Road, this project is one of the infrastructure projects launched by the Singapore government. In addition, it is the first monolithic underground substation in Singapore, where most of the electrical machinery will be housed in the basement and will supply power to the Ang Mo Kio development in Singapore when completed. The project commenced work in 2017 and was completed in 2020.`,
    website:"",
    location: {lat: 1.3855575, lng: 103.8193836},
    images: [
      {id: 0, imageSrc: require('@/assets/images/constructions/project-public/tagore/21625029983_.pic.jpg')},
      {id: 1, imageSrc: require('@/assets/images/constructions/project-public/tagore/41625029983_.pic.jpg')},
      {id: 2, imageSrc: require('@/assets/images/constructions/project-public/tagore/61625029984_.pic.jpg')},
      {id: 3, imageSrc: require('@/assets/images/constructions/project-public/tagore/101625030013_.pic.jpg')},
      {id: 4, imageSrc: require('@/assets/images/constructions/project-public/tagore/111625030014_.pic.jpg')},
    ]
  },
}